<template>
  <v-app>
    <AppSidebar v-if="showSidebar" />
    <v-main class="d-flex flex-column" style="min-height: 100vh">
      <router-view class="flex-grow-1" />
      <PriorFooter />
    </v-main>
    <TableSettingsDialog v-if="showSidebar" v-model="tableSettingsStore.isDialogOpen" />
  </v-app>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore, useTableSettingsStore } from "@/stores";
import AppSidebar from "@/components/AppSidebar.vue";
import PriorFooter from "@/components/PriorFooter.vue";
import TableSettingsDialog from "@/components/dashboard/TableSettingsDialog.vue";

const route = useRoute();
const authStore = useAuthStore();
const tableSettingsStore = useTableSettingsStore();

const publicRoutes = [
  "login",
  "complete-registration",
  "password-reset-request",
  "password-reset",
  "confirmEmail",
  "health-check",
];

const showSidebar = computed(() => {
  return authStore.loggedIn && !publicRoutes.includes(route.name);
});
</script>
